import { AnimatePresence, motion } from 'framer-motion';
import CavelaDirectRfqTabsPanel, {
  CavelaDirectRfqTab
} from 'src/features/product/product-detail/ui/quotes-tab/CavelaDirectRfqTabsPanel';
import RfqDrawerTrigger from 'src/features/rfq-builder/ui/rfq-drawer/RfqDrawerTrigger';
import { RFQ } from 'src/shared/types/product';

import { cn } from 'src/shared/components/ui';

export type CavelaDirectRfqSlideOverTab = CavelaDirectRfqTab;

interface CavelaDirectRfqSlideOverProps {
  rfq: RFQ;
  isDrawerOpen: boolean;
  onToggle: () => void;
  isMobile: boolean;
  activeTab: CavelaDirectRfqSlideOverTab;
  onActiveTabChange: (tab: CavelaDirectRfqSlideOverTab) => void;
  drawerPanelClassName?: string;
  triggerClassName?: string;
}

/**
 * Read-only RFQ panel for Cavela Direct: same slide-over chrome as the builder,
 * without {@link RfqDrawer} editing / sourcing flows.
 */
const CavelaDirectRfqSlideOver: React.FC<CavelaDirectRfqSlideOverProps> = ({
  rfq,
  isDrawerOpen,
  onToggle,
  isMobile,
  activeTab,
  onActiveTabChange,
  drawerPanelClassName,
  triggerClassName
}) => {
  const drawerWidth = isMobile ? '100%' : '50%';

  return (
    <>
      <AnimatePresence>
        {isDrawerOpen && (
          <motion.div
            initial={{ x: '100%', opacity: 0 }}
            animate={{
              x: 0,
              opacity: 1,
              width: drawerWidth
            }}
            exit={{ x: '100%', opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className={cn(
              'fixed top-0 right-0 bottom-0 z-[0] flex h-dvh flex-col overflow-hidden bg-white',
              drawerPanelClassName
            )}
          >
            <RfqDrawerTrigger
              onClick={onToggle}
              isDrawerOpen={true}
              className={triggerClassName}
            />
            <div className="relative top-4 flex min-h-0 flex-1 flex-col">
              <div
                className="min-h-0 flex-1 overflow-y-auto cavela-scrollbar px-0 pb-10"
                style={{
                  backgroundImage: `
          linear-gradient(to right, rgba(59, 130, 246, 0.05) 1px, transparent 1px),
          linear-gradient(to bottom, rgba(59, 130, 246, 0.05) 1px, transparent 1px)
        `,
                  backgroundSize: '40px 40px',
                  backgroundColor: '#FFF'
                }}
              >
                <div className="mx-auto max-w-[640px] min-w-0 break-words flex flex-col mobile:ml-4 mobile:mr-2">
                  <CavelaDirectRfqTabsPanel
                    rfq={rfq}
                    activeTab={activeTab}
                    onActiveTabChange={onActiveTabChange}
                    timelineOpen={isDrawerOpen}
                    stickyTabs
                  />
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default CavelaDirectRfqSlideOver;
